import Model from './Model';

export default class Test extends Model {
    main_subject;
    sub_subject;
    date_taken;
    date_closed;
    price;
}



// WEBPACK FOOTER //
// ./src/models/Test.js